"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePeriod = void 0;
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["MONTH"] = "month";
    TimePeriod["QUARTER"] = "quarter";
    TimePeriod["YEAR"] = "year";
})(TimePeriod || (exports.TimePeriod = TimePeriod = {}));
